import { FC } from 'react'
import { FormattedNumber } from 'react-intl'

type C1CountDisplayProps = {
    value: number | string | undefined
    maxCount?: number
}

/**
 * A component that displays a count value with optional max count truncation.
 * When the value exceeds maxCount, it displays as "maxCount+".
 * Otherwise, it formats numbers using FormattedNumber or displays the value as-is.
 */
export const C1CountDisplay: FC<C1CountDisplayProps> = ({ value, maxCount }) => {
    const displayValue = maxCount !== undefined && typeof value === 'number' && value > maxCount
        ? `${maxCount}+`
        : typeof value === 'number' ? <FormattedNumber value={value} /> : value

    return <>{displayValue}</>
}
